import { unAuthenticatedUser } from "src/utilities/storage"
import { setSessionId } from "src/services/utilities";
import { isNotEmpty, returnIsNotEmptyOrTrue } from "src/utilities/hasValue";
import { pathOr, set, lensPath } from "ramda";
import { timeStampInISOFormat } from "src/utilities/formatDate";


export const getUserSpecificIntentBySession = () => {
  const workFlowIntents = unAuthenticatedUser.workFlowIntent.get();
  return isNotEmpty(workFlowIntents) ? workFlowIntents : {};
};


export const updateUserSpecificIntentInSession = (data: any) => {

  const applicationStatedAt = pathOr('', ['intents', 0, 'created_at'], data)
  const _data = returnIsNotEmptyOrTrue(
    pathOr('', ['metadata', 'application_started_at'], data) && applicationStatedAt,
    data,
    set(
      lensPath(['metadata', 'application_started_at']),
      applicationStatedAt || timeStampInISOFormat()
    )(data)
  )
  unAuthenticatedUser.workFlowIntent.set(JSON.stringify(_data))
  return setSessionId(_data);
}

export const updateUserSpecificIntentInSessionPromise = (data: any) => {
  return new Promise((resolve, _reject) => {
    resolve(updateUserSpecificIntentInSession(
      data
    ))
  })
}
